var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6845 37.7293C20.5052 37.8973 20.2638 38 19.9998 38C19.7352 38 19.4938 37.8973 19.3152 37.7293L9.50317 28.5107C6.52584 25.7133 4.6665 21.7407 4.6665 17.3333C4.6665 8.86533 11.5312 2 19.9998 2C28.4678 2 35.3332 8.86533 35.3332 17.3333C35.3332 21.7407 33.4738 25.7133 30.4965 28.5107L20.6845 37.7293ZM19.9998 11.3333C16.6858 11.3333 13.9998 14.0193 13.9998 17.3333C13.9998 20.6473 16.6858 23.3333 19.9998 23.3333C23.3138 23.3333 25.9998 20.6473 25.9998 17.3333C25.9998 14.0193 23.3138 11.3333 19.9998 11.3333Z",
    fill: "#0496FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/Marker.d1215e8905a44de021ec3a1bb99af715.svg";
export { ForwardRef as ReactComponent };